import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';

import SelectOption from '../../components/Inputs/Select/Select';

import EnumService from '../../services/Enum';

export class DependenciaAdministrativaFilter extends Component {
    constructor(props) {
        super(props);
        props.parentRef(this);
        this.state = {
            filters: {
                adminDep: '',
            },
            optionsDepAdmin: [],
        }
    }

    // INPUTS
    handleChange = e => {
        this.setState({ 
            filters: { [e.target.name]: e.target.value, } 
        }, () => {
            if (this.props.onChange) {
                this.props.onChange(e.target.value);
            }
        });
    }

    async componentDidMount() {
        const depsAdmin = await EnumService.listarDependenciasAdministrativas().then(res => res.data);

        if (this.props.withPublicGroup)
            depsAdmin.push({ value: 'PUBLICA', label: 'Pública' });

        if (this.props.withSemEscolaInformada)
            depsAdmin.push({ value: 'SEM ESCOLA INFORMADA', label: 'Sem Escola Informada' });

        this.setState({ optionsDepAdmin: [...depsAdmin], });
    }

    render () {
        return (
            <Grid item sm={12} lg={2}>
                <SelectOption
                    label="Dep. Administrativa"
                    name='adminDep'
                    value={this.state.filters.adminDep}
                    onChange={(e) => this.handleChange(e)}
                    options={this.state.optionsDepAdmin}
                />
            </Grid>
        )
    }
}

export default DependenciaAdministrativaFilter;